/**
 * Authorization Permission/Roles
 */
const authPermissions = {
  manage: ['admin', 'staff', 'sales'],
  /** PGSS-5304 — invoice vs order discrepancy panel + Accept/Flag (matches backend Staff/Admin gate). */
  invoiceDiscrepancy: ['admin', 'staff'],
  /** PGSS-5326 — reverse a returned payment (matches backend Staff/Admin gate). */
  paymentReversal: ['admin', 'staff'],
  /** PGSS-5748 part 2b — print box labels from a customer order or a container (matches backend Staff/Admin gate). */
  boxLabels: ['admin', 'staff'],
};

export default authPermissions;
